import z from 'zod';

export const companyProfileSchema = z.object({
  name: z
    .string()
    .min(1, 'Company name is required')
    .max(100, 'Company name must be less than 100 characters')
    .transform(val => val.trim().replace(/\s{2,}/g, ' ')),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^[0-9]+$/, 'Phone number must contain only digits')
    .min(7, 'Phone number must be at least 7 digits')
    .max(15, 'Phone number must be less than 15 digits'),
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  website: z
    .string()
    .url('Please enter a valid URL')
    .or(z.literal(''))
    .optional(),
  address: z
    .string()
    .min(1, 'Address is required')
    .max(500, 'Address must be less than 500 characters'),
  trn: z
    .string()
    .min(1, 'TRN is required')
    .max(50, 'TRN must be less than 50 characters'),
  stamp: z.string().optional().nullable(),
  waterMark: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
  bankLogo: z.string().optional().nullable(),
});

export type TCompanyProfileFormType = z.infer<typeof companyProfileSchema>;
